const ButtonBack = ({ pagesToBack = 1, url, top}) => {
  const handleBack = () => {
    if (url) {
      if (top) {
        window.top.location.href = url;
      } else {
        window.location.href = url;
      }
    } else if (window.history.length > pagesToBack) {
      window.history.go(pagesToBack * -1);
    } else {
      if (top) {
        window.top.location.href = process.env.REACT_APP_HOME_AUDI_URL;
      } else {
        window.location.href = process.env.REACT_APP_HOME_AUDI_URL;
      }
    }
  };
  
  return (
    <button
      className="button-back"
      onClick={handleBack}
    >
      <svg height="20" width="24" xmlns="http://www.w3.org/2000/svg">
        <path d="M7 10l5.5 6.5L18 10" fill="none" stroke="currentColor"></path>
      </svg>
      <span>Volver</span>
    </button>
  );
};

export default ButtonBack;